// Constants shared across the monorepo

export const API_PATHS = {
  CORE: '/api/core',
  PROCTORING: '/api/proctoring',
  ASSESSMENT: '/api/assessment',
  SCHEDULING: '/api/scheduling',
};

export const ENVIRONMENTS = {
  DEVELOPMENT: 'development',
  STAGING: 'staging',
  PRODUCTION: 'production',
};

export const DEFAULT_PAGINATION = {
  PAGE: 1,
  LIMIT: 10,
};

export const HTTP_STATUS = {
  OK: 200,
  CREATED: 201,
  BAD_REQUEST: 400,
  UNAUTHORIZED: 401,
  FORBIDDEN: 403,
  NOT_FOUND: 404,
  INTERNAL_SERVER_ERROR: 500,
};

export const ERROR_CODES = {
  UI: {
    SESSION_REDIRECT_INVALID_STATE: {
      CODE: '6913cb724e62',
      REASON: 'Session is not in a valid state. Please close this window and start over.',
    },
    SESSION_REDIRECT_TIMEOUT: {
      CODE: '722694e613cb',
      REASON: 'Session redirect timeout. Please close this window and start over.',
    },
    SESSION_REDIRECT_CATCH: {
      CODE: '6b724e6213c',
      REASON: 'Session redirect catch. Please close this window and start over.',
    },
  },
};
